import { render } from "./TheStories.vue?vue&type=template&id=dc060268&scoped=true"
import script from "./TheStories.vue?vue&type=script&lang=js"
export * from "./TheStories.vue?vue&type=script&lang=js"

import "./TheStories.vue?vue&type=style&index=0&id=dc060268&lang=scss&scoped=true"
import "./TheStories.vue?vue&type=style&index=1&id=dc060268&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc060268"]])

export default __exports__